import { UserListResponse } from 'src/models/user.models'

export enum NotificationStatus {
  all = 'all',
  read = 'read',
  unread = 'unread',
}

export interface NotificationListResponse {
  action: string
  actionText: string
  body: string
  subject?: string
  id: string
  status: NotificationStatus
  timestamp: string
  triggeredBy: UserListResponse
}

export class NotificationListModel {
  public action: string
  public actionText: string
  public body: string
  public subject: string
  public id: string
  public status: NotificationStatus
  public timestamp: string
  public triggeredBy: UserListResponse

  public constructor(data: NotificationListResponse) {
    this.action = data.action
    this.actionText = data.actionText
    this.body = data.body
    this.subject = data.subject ?? ''
    this.id = data.id
    this.status = data.status
    this.timestamp = data.timestamp
    this.triggeredBy = data.triggeredBy
  }
}
